import * as React from 'react';

import { ModalFrame, ModalFrameInner } from 'components/modal';
import InfoNote from 'components/info-note/InfoNote';
import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';

import CcmCampaignEdit from 'modules/campaigns/components/ccm/edit/CcmCampaignEdit';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaign-edit-modal.scss';

applyTranslations(require('./ccm-campaign-edit-modal.i18n.json'));

import type {
  CampaignType,
  PromiseAction
} from 'types';

type Props = {
  campaignId: number,
  organizationId: number,
  brandProfileId: number,
  onCloseModal: () => PromiseAction,
  hideNotes?: boolean,
  campaignType?: CampaignType
};

const MSG_KEY = 'ccm_campaign_edit_modal';

const CcmCampaignEditModal: React.FC<Props> = ({
  campaignId,
  organizationId,
  brandProfileId,
  hideNotes,
  campaignType,
  onCloseModal
}): JSX.Element => (
  <div className="ccm-campaign-edit-modal">
    <ModalFrame
      title={__t(`${MSG_KEY}.title`)}
      subtitle={
        campaignType === 'ccm_creatorless'
          ? __t(`${MSG_KEY}.subtitle`)
          : undefined
      }
      classNameFrame={
        campaignType === 'ccm_creatorless'
          ? 'ccm-creatorless-campaign-edit-modal'
          : undefined
      }
    >
      <ModalFrameInner>
        {hideNotes ? null : (
          <React.Fragment>
            <InfoNote>
              {__t(`${MSG_KEY}.info_note`)}
            </InfoNote>
            <VerticalSpacing type="medium" />
          </React.Fragment>
        )}
        <CcmCampaignEdit
          campaignId={campaignId}
          organizationId={organizationId}
          brandProfileId={brandProfileId}
          onCloseModal={onCloseModal}
        />
      </ModalFrameInner>
    </ModalFrame>
  </div>
);

export default CcmCampaignEditModal;
